import { render, staticRenderFns } from "./PrivacyMobile.vue?vue&type=template&id=5048fc95&scoped=true"
import script from "./PrivacyMobile.vue?vue&type=script&lang=ts"
export * from "./PrivacyMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5048fc95",
  null
  
)

export default component.exports